<template>
    <div class="driver-summary">
        <h3 class="green-header">Driver</h3>
        <dl class="dl-horizontal">
            <dt>First Name</dt>
            <dd>{{ firstName }}</dd>
            <dt>Middle Name</dt>
            <dd>{{ middleName }}</dd>
            <dt>Last Name</dt>
            <dd>{{ lastName }}</dd>
            <dt>Date Of Birth</dt>
            <dd>{{ dob }}</dd>
            <dt>Drivers License</dt>
            <dd>{{ driversLicenseNumber }}</dd>
            <dt>Drivers State</dt>
            <dd>{{ driversLicenseState }}</dd>
            <dt>Email</dt>
            <dd>{{ email }}</dd>
            <dt>Phone</dt>
            <dd>{{ phoneNumber }}</dd>
            <dt>Address</dt>
            <dd>{{ address }}</dd>
            <dt>Other Drivers</dt>
            <dd>{{ otherDrivers }}</dd>
        </dl>
    </div>

</template>

<script>

export default {
  name: 'DriverSummary',
  props: {
    'firstName': String,
    'middleName': String,
    'lastName': String,
    'dob': String,
    'driversLicenseNumber': String,
    'driversLicenseState': String,
    'email': String,
    'phoneNumber': String,
    'address': String,
    'otherDrivers': String,
  },
}
</script>

<style>
</style>
